module.exports = __webpack_public_path__ + "img/JO.fdbc7fa6.svg";